module.exports = require('./helpers/bundle-url').getBundleURL('aSzjM') + "logo.c51670a8.svg";